export default from './MortgagePaymentQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MortgagePaymentQuestion/index.js